import type { AxiosResponse } from "axios";
import type { Manuals, ManualUrl } from "@/models/manuals";
import { httpClient } from "./API";

export const getManualsAPI = async (): Promise<AxiosResponse<Manuals[]>> => {
  return httpClient.get("core/internal/calgary/manuals/");
};

export const getManualUrlAPI = async (
  id: number,
): Promise<AxiosResponse<ManualUrl>> => {
  return httpClient.get(`core/internal/calgary/manuals/${id}`);
};
